import { BackArrowIcon, CopyIcon, TickIcon } from "@/assets/icons/admin";
import { useGetAllPlayers, useUpdatePlayer } from "@/services/admin.service";
import { PlayerUser } from "@/types";
import { Button, Chip, Input } from "@nextui-org/react";
import { format } from "date-fns";
import React, { useState } from "react";
import { toast } from "react-toastify";

interface EditPlayerListProps {
  itemData: Partial<PlayerUser>;
  onCancel: () => void;
  items: any[];
}

const EditPlayerList: React.FC<EditPlayerListProps> = ({
  itemData,
  onCancel,
}) => {
  const [username, setUsername] = useState(itemData.userName);
  const email = itemData.email;
  const [fullName, setFullName] = useState(itemData.fullName);
  const [kycStatus, setKycStatus] = useState(
    itemData.kycStatus ? itemData.kycStatus : null,
  );

  const [status, setStatus] = useState(itemData.status);

  const { refetch } = useGetAllPlayers({ page: 1, pageSize: 10 });
  const updatePlayer = useUpdatePlayer();

  const handleStatusChange = (e: any) => {
    setStatus(e.target.value);
    console.log(e.target.value);
  };

  const handleCopyText = (text: string) => {
    const textToCopy = text;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log("Text copied to clipboard:", textToCopy);
      })
      .catch((error) => {
        console.error("Error copying text to clipboard:", error);
      });
  };

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    if (name === "username") {
      setUsername(value);
    } else if (name === "fullname") {
      setFullName(value);
    }
  };

  const handleSave = () => {
    // const isEmailValid = /\S+@\S+\.\S+/.test(email!);
    // setIsEmailValid(isEmailValid);
    const updateData: Partial<PlayerUser> = {
      fullName: fullName,
      status: selectedStatus,
    };

    if (username !== itemData.userName) {
      updateData.userName = username;
    }

    console.log("updateData : ", updateData);

    updatePlayer.mutate(
      { id: itemData.id!, data: updateData },
      {
        onSuccess: () => {
          console.log("Successfully updated player");
          refetch();
          toast.success("Successfully updated player");
        },
        onError: (err) => {
          console.error("Error updating player:", err);
          toast.error("Error updating player");
        },
      },
    );
  };

  const formatBalance = (balance: number | undefined) => {
    if (typeof balance !== "number") {
      return "";
    }

    const balanceString = balance.toString();
    const [integerPart, fractionalPart] = balanceString.split(".");
    const truncatedFractionalPart = fractionalPart
      ? fractionalPart.slice(0, 3)
      : "000";
    return `${integerPart}.${truncatedFractionalPart}`;
  };

  const capitalize = (str: any) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const [selectedStatus, setSelectedStatus] = useState(itemData.status);

  const handleCheckboxChange = (status: any) => {
    if (selectedStatus === status) {
      setSelectedStatus(""); // Deselect if the same checkbox is clicked again
    } else {
      setSelectedStatus(status); // Select the new checkbox
    }
  };

  return (
    <div>
      <div className="font-ubuntu mb-4 w-full text-center text-2xl font-semibold text-white sm:flex sm:items-center sm:justify-between ">
        <div>
          <span>
            <Button
              isIconOnly
              onClick={onCancel}
              className="transparent-bg float-left ml-[-11px] h-auto w-auto"
            >
              <BackArrowIcon />
            </Button>
            <p className="text-sm sm:float-left sm:text-lg md:text-lg lg:text-lg">
              Edit Player Details
            </p>
          </span>
        </div>
        {/* Dekstop */}
        <div className="hidden items-center pr-4 sm:flex sm:justify-center">
          <span className="mt-1 font-kanit text-xl font-bold">
            KYC Verification
          </span>
          {kycStatus === "completed" ? (
            <>
              <div className="ml-5">
                <Chip
                  className="kyc-verified font-inter text-[15px] font-normal text-[#11FF1B]"
                  radius="sm"
                >
                  Verified
                </Chip>
              </div>
            </>
          ) : (
            <>
              <div className="ml-5">
                <Chip
                  className="kyc-unverified font-inter text-[15px] font-normal text-[#FF1111]"
                  radius="sm"
                >
                  Unverified
                </Chip>
              </div>
            </>
          )}
        </div>
      </div>
      {/* Mobile */}
      <div className="my-3 flex items-center justify-between pr-1 sm:hidden">
        <span className="mt-1 pl-1 font-kanit text-xl font-bold">
          KYC Verification
        </span>
        {kycStatus === "completed" ? (
          <>
            <div className="ml-5">
              <Chip
                className="kyc-verified font-inter text-[15px] font-normal text-[#11FF1B]"
                radius="sm"
              >
                Verified
              </Chip>
            </div>
          </>
        ) : (
          <>
            <div className="ml-5">
              <Chip
                className="kyc-unverified font-inter text-[15px] font-normal text-[#FF1111]"
                radius="sm"
              >
                Unverified
              </Chip>
            </div>
          </>
        )}
      </div>
      <div className="flex w-full flex-col gap-6">
        <div className="flex flex-row">
          <div className="basis-1/2 p-1 sm:p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Username
            </label>
            <Input
              value={username}
              onChange={handleInputChange}
              name="username"
              className={`data-added-input-bg bg-white-5 w-full !cursor-text rounded-md border border-solid border-white border-opacity-50 text-white`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
              isReadOnly
            ></Input>
          </div>
          <div className="basis-1/2 p-1 sm:p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Player Key
            </label>
            <Input
              id="playerkey"
              name="playerkey"
              className={`data-added-input-bg bg-white-5 w-full !cursor-text rounded-md border border-solid border-white border-opacity-50 text-white`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
              value={itemData.id}
              readOnly
              endContent={
                <Button
                  isIconOnly
                  onClick={() => handleCopyText(itemData.id ?? "")}
                  className="transparent-bg h-auto w-auto"
                >
                  <CopyIcon />
                </Button>
              }
              isReadOnly
            ></Input>
          </div>
        </div>
        <div className="flex flex-row">
          <div className="basis-1/2 p-1 sm:p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Fullname
            </label>
            <Input
              value={fullName || ""}
              onChange={handleInputChange}
              name="fullname"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
              isReadOnly
            ></Input>
          </div>
          <div className="basis-1/2 p-1 sm:p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Email
            </label>
            <Input
              disabled={true}
              value={email}
              name="email"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
        </div>
        {/* hidden in smaller screens */}
        <div className="hidden sm:flex sm:flex-row">
          <div className="basis-1/2 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Join Date
            </label>
            <Input
              disabled={true}
              value={
                itemData?.createdAt
                  ? format(itemData?.createdAt, "dd/MM/yyyy hh:mm:ss")
                  : ""
              }
              name="joindate"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          <div className="basis-1/2 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Last Login
            </label>
            <Input
              disabled={true}
              value={
                itemData?.lastLogin
                  ? format(itemData?.lastLogin, "dd/MM/yyyy hh:mm:ss")
                  : ""
              }
              name="lastlogin"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          <div className="basis-1/2 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Last Deposit
            </label>
            <Input
              disabled={true}
              value={
                itemData.Transaction != undefined &&
                itemData?.Transaction.length > 0
                  ? format(
                      itemData?.Transaction[0].createdAt,
                      "dd/MM/yyyy hh:mm:ss",
                    )
                  : ""
              }
              name="lastdeposit"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          <div className="basis-1/2 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Last IP
            </label>
            <Input
              disabled={true}
              value={itemData.lastIP}
              name="lastip"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
        </div>

        {/* hidden on larger screens */}
        <div className="flex w-full flex-col gap-6 sm:hidden md:hidden lg:hidden xl:hidden 2xl:hidden">
          <div className="flex flex-row flex-wrap">
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Join Date
              </label>
              <Input
                disabled={true}
                value={format(itemData.createdAt!, "dd/MM/yyyy hh:mm:ss")}
                name="joindate"
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Last Login
              </label>
              <Input
                disabled={true}
                value={
                  itemData?.lastLogin
                    ? format(itemData?.lastLogin, "dd/MM/yyyy hh:mm:ss")
                    : ""
                }
                name="lastlogin"
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
          </div>
          <div className="flex flex-row flex-wrap">
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Last Deposit
              </label>
              <Input
                disabled={true}
                value={
                  itemData.Tier?.updatedAt !== undefined
                    ? format(itemData.Tier?.updatedAt, "dd/MM/yyyy hh:mm:ss")
                    : ""
                }
                name="lastdeposit"
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Last IP
              </label>
              <Input
                disabled={true}
                value={itemData.lastIP}
                name="lastip"
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
          </div>
        </div>
        {/* hidden in smaller screens */}
        <div className="hidden sm:flex sm:flex-row">
          <div className="basis-1/4 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Tier
            </label>
            <Input
              disabled={true}
              value={capitalize(itemData.Tier?.name)}
              name="tier"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          <div className="basis-1/4 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Balance
            </label>
            <Input
              disabled={true}
              value={`$${formatBalance(itemData.accountBalance)}`}
              name="balance"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          <div className="basis-1/4 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Bonus Balance
            </label>
            <Input
              disabled={true}
              value={`$${formatBalance(itemData.bonusBalance)}`}
              name="bonusBalance"
              className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
              classNames={{
                inputWrapper: ["!cursor-text text-sm bg-transparent"],
              }}
            ></Input>
          </div>
          {/* <div className="basis-2/4 p-3">
            <label
              htmlFor="firstName"
              className="field-label mb-2 block text-sm font-normal text-white"
            >
              Status
            </label>
            <div className="flex flex-row gap-3">
              <div className="flex items-center justify-center">
                <input
                  checked={status === "ACTIVE"}
                  id="default-radio-1"
                  type="radio"
                  value="ACTIVE"
                  name="default-radio"
                  className="text-blue-600 h-4 w-4 "
                  onChange={handleStatusChange}
                />
                <label
                  htmlFor={"default-radio-1"}
                  className="text-md ms-2 items-center justify-center font-medium "
                >
                  Active
                </label>
              </div>
              <div className="flex items-center justify-center">
                <input
                  checked={status === "IN_ACTIVE"}
                  id="default-radio-2"
                  type="radio"
                  value="IN_ACTIVE"
                  name="default-radio"
                  className="text-blue-600 h-4 w-4 "
                  onChange={handleStatusChange}
                />
                <label
                  htmlFor={"default-radio-2"}
                  className="text-md ms-2 items-center justify-center font-medium "
                >
                  Inactive
                </label>
              </div>
              <div className="flex items-center justify-center">
                <input
                  checked={status === "SUSPEND"}
                  id="default-radio-3"
                  type="radio"
                  value="SUSPEND"
                  name="default-radio"
                  className="text-blue-600 h-4 w-4 "
                  onChange={handleStatusChange}
                />
                <label
                  htmlFor={"default-radio-3"}
                  className="text-md ms-2 items-center justify-center font-medium "
                >
                  Suspend
                </label>
              </div>
            </div>
          </div> */}
          <div className="basis-2/4 p-3">
            <label
              htmlFor="firstName"
              className="field-label  mb-2 block text-sm font-normal text-white"
            >
              Status
            </label>
            <div className="flex flex-wrap gap-16">
              <div className="flex">
                <label className="white-checkbox">
                  <input
                    value="ACTIVE"
                    type="checkbox"
                    checked={selectedStatus === "ACTIVE"}
                    onChange={() => handleCheckboxChange("ACTIVE")}
                  />
                  <span className="checkmark">
                    {selectedStatus === "ACTIVE" && <TickIcon />}
                  </span>
                </label>
                <span>Active</span>
              </div>
              <div className="flex">
                <label className="white-checkbox">
                  <input
                    value="IN_ACTIVE"
                    type="checkbox"
                    checked={selectedStatus === "IN_ACTIVE"}
                    onChange={() => handleCheckboxChange("IN_ACTIVE")}
                  />
                  <span className="checkmark">
                    {selectedStatus === "IN_ACTIVE" && <TickIcon />}
                  </span>
                </label>
                <span>Inactive</span>
              </div>
              <div className="flex">
                <label className="white-checkbox">
                  <input
                    value="SUSPEND"
                    type="checkbox"
                    checked={selectedStatus === "SUSPEND"}
                    onChange={() => handleCheckboxChange("SUSPEND")}
                  />
                  <span className="checkmark">
                    {selectedStatus === "SUSPEND" && <TickIcon />}
                  </span>
                </label>
                <span>Suspend</span>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden in larger screens */}
        <div className="flex w-full flex-col gap-6 sm:hidden md:hidden lg:hidden xl:hidden 2xl:hidden">
          <div className="flex flex-row flex-wrap">
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Tier
              </label>
              <Input
                name="tier"
                value={capitalize(itemData.Tier?.name)}
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
            <div className="basis-1/2 p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="field-label mb-2 block text-sm font-normal text-white"
              >
                Balance
              </label>
              <Input
                name="balance"
                value={`$${formatBalance(itemData.accountBalance)}`}
                className={`data-added-input-bg "border-white bg-white-5 text-white" w-full !cursor-text rounded-md border border-solid border-opacity-50`}
                classNames={{
                  inputWrapper: [
                    "!cursor-text",
                    "rounded-md",
                    "border",
                    "border-solid",
                    "border-white",
                    "border-opacity-50",
                    "bg-white-5",
                    "text-sm",
                    "bg-transparent",
                  ],
                }}
              ></Input>
            </div>
          </div>
          {/* <label
            htmlFor="firstName"
            className="field-label mb-2 block text-sm font-normal text-white"
          >
            Status
          </label>
          <div className="flex flex-row gap-3">
            <div className="flex items-center justify-center">
              <input
                checked={status === "ACTIVE"}
                id="default-radio-1"
                type="radio"
                value="ACTIVE"
                name="default-radio-m"
                className="text-blue-600 h-4 w-4 "
                onChange={handleStatusChange}
              />
              <label
                htmlFor={"default-radio-1"}
                className="text-md ms-2 items-center justify-center font-medium "
              >
                Active
              </label>
            </div>
            <div className="flex items-center justify-center">
              <input
                checked={status === "IN_ACTIVE"}
                id="default-radio-2"
                type="radio"
                value="IN_ACTIVE"
                name="default-radio-m"
                className="text-blue-600 h-4 w-4 "
                onChange={handleStatusChange}
              />
              <label
                htmlFor={"default-radio-2"}
                className="text-md ms-2 items-center justify-center font-medium "
              >
                Inactive
              </label>
            </div>
            <div className="flex items-center justify-center">
              <input
                checked={status === "SUSPEND"}
                id="default-radio-3"
                type="radio"
                value="SUSPEND"
                name="default-radio-m"
                className="text-blue-600 h-4 w-4 "
                onChange={handleStatusChange}
              />
              <label
                htmlFor={"default-radio-3"}
                className="text-md ms-2 items-center justify-center font-medium "
              >
                Suspend
              </label>
            </div>
          </div> */}
          <div className="flex flex-row flex-wrap">
            <div className="basis-full p-1 sm:p-3">
              <label
                htmlFor="firstName"
                className="mb-2 block text-sm font-normal text-white"
              >
                Status
              </label>
              <div className="flex flex-wrap gap-8">
                <div className="flex">
                  <label className="white-checkbox">
                    <input
                      value="ACTIVE"
                      type="checkbox"
                      checked={selectedStatus === "ACTIVE"}
                      onChange={() => handleCheckboxChange("ACTIVE")}
                    />
                    <span className="checkmark">
                      {selectedStatus === "ACTIVE" && <TickIcon />}
                    </span>
                  </label>
                  <span>Active</span>
                </div>
                <div className="flex">
                  <label className="white-checkbox">
                    <input
                      value="IN_ACTIVE"
                      type="checkbox"
                      checked={selectedStatus === "IN_ACTIVE"}
                      onChange={() => handleCheckboxChange("IN_ACTIVE")}
                    />
                    <span className="checkmark">
                      {selectedStatus === "IN_ACTIVE" && <TickIcon />}
                    </span>
                  </label>
                  <span>Inactive</span>
                </div>
                <div className="flex">
                  <label className="white-checkbox">
                    <input
                      value="SUSPEND"
                      type="checkbox"
                      checked={selectedStatus === "SUSPEND"}
                      onChange={() => handleCheckboxChange("SUSPEND")}
                    />
                    <span className="checkmark">
                      {selectedStatus === "SUSPEND" && <TickIcon />}
                    </span>
                  </label>
                  <span>Suspend</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex flex-row gap-3">
          <div className="flex items-center justify-center">
            <input
              id="default-radio-1"
              type="radio"
              value="SD"
              name="default-radio"
              className="w-4 h-4 text-blue-600 "
            />
            <label className="items-center justify-center font-medium text-md ms-2 ">
              Active
            </label>
          </div>
          <div className="flex items-center justify-center">
            <input
              id="default-radio-2"
              type="radio"
              value="SD"
              name="default-radio"
              className="w-4 h-4 text-blue-600 "
            />
            <label className="items-center justify-center font-medium text-md ms-2 ">
              Inactive
            </label>
          </div>
          <div className="flex items-center justify-center">
            <input
              id="default-radio-2"
              type="radio"
              value="SD"
              name="default-radio"
              className="w-4 h-4 text-blue-600 "
            />
            <label className="items-center justify-center font-medium text-md ms-2 ">
              Suspend
            </label>
          </div>
        </div> */}

        <div className="flex w-full flex-col gap-6">
          <div className="flex flex-row">
            <div className="w-full">
              <div className="sm:float-right">
                <Button
                  onClick={handleSave}
                  className="admin-common-button-gradient font-ubuntu w-full rounded-md pl-10 pr-10 text-base font-bold"
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPlayerList;
